function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var defaultOptions = {
  type: 'text/javascript',
  charset: 'utf8',
  async: true
};
function loadScript(src, options) {
  var head = document.head || document.getElementsByTagName('head')[0];
  var script = document.createElement('script');
  var appliedOptions = _objectSpread({}, defaultOptions, options);
  script.type = appliedOptions.type;
  script.charset = appliedOptions.charset;
  script.async = appliedOptions.async;
  script.src = src;
  if (appliedOptions.text) {
    script.text = appliedOptions.text;
  }
  if (appliedOptions.attrs) {
    for (var key in appliedOptions.attrs) {
      script.setAttribute(key, appliedOptions.attrs[key]);
    }
  }
  var promise = new Promise(function (resolve, reject) {
    script.onload = function onload() {
      this.onload = this.onerror = null;
      resolve(script);
    };
    script.onerror = function onerror() {
      this.onload = this.onerror = null;
      reject(new Error("Failed to load ".concat(this.src, "}")));
    };
  });
  head.appendChild(script);
  return promise;
}
export default loadScript;